export class CompleteAttendeeProfileDTO {
  firstName: string = "";
  lastName: string = "";
  username: string = "";
  email: string = "";
  language: string = "";
  address: string = "";
  adress: string = "";
  dob: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  phone: string = "";
  gender: string = "";
  profilePicUrl: any;
  profilePicUri: File | string = "";
  profilePicId: number = 0;
  profileCompleted: boolean;

  constructor(data: Partial<CompleteAttendeeProfileDTO> = {}){
    Object.assign(this,data);
  }
}


export class FamilyInfoDTO  {
  firstName: string = "";
  lastName: string = "";
  language: string = "";
  username: string = "";
  dob: string = "";
  phone: string = "";
  gender: string = "";
  interest: string = "";
  password: string = "";
  retypePassword: string = "";
  skillLevel: SKILL_LEVELS = SKILL_LEVELS.APPROPRIATE_FOR_AGE_LEVEL;
  profilePicUrl: any;
  profilePicId: number;

  constructor(data: Partial<FamilyInfoDTO> = {}){
      Object.assign(this,data);
  }
}


enum SKILL_LEVELS{
  EXCEPTIONAL_LEARNER = 'EXCEPTIONAL_LEARNER',
  APPROPRIATE_FOR_AGE_LEVEL = 'APPROPRIATE_FOR_AGE_LEVEL',
  BOTH = 'BOTH',
}